import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { QuestionPrompt } from './ui/question_prompt.js';

export { QuestionPrompt } from './ui/question_prompt.js';

/** Entrada de catálogo do `question_prompt` — slot `composer`, interativo. */
export const questionPromptEntry: GenUiEntry<Extract<ChatUi, { kind: 'question_prompt' }>> = {
  kind: 'question_prompt',
  slot: 'composer',
  render: (props) => <QuestionPrompt {...props} />,
};
